<template>
  <basic-dialog v-model="showDialog" max-width="800px">
    <template v-slot:title>
      <span>{{ $t('terms_popup.title') }}</span>
    </template>
    <v-card-text class="pt-4 terms-content">
      <ul>
        <li v-html="$t('terms_popup.terms1')"></li>
        <li v-html="$t('terms_popup.terms2')"></li>
        <li v-html="$t('terms_popup.terms3')"></li>
        <li v-html="$t('terms_popup.terms4')"></li>
        <li v-html="$t('terms_popup.terms5')"></li>
      </ul>
      <p><a :href="termsLink" class="white--text" target="_blank">{{ $t('terms_popup.read_terms_here', {termsLink: termsLink}) }}</a></p>
    </v-card-text>
    <template v-slot:actions>
      <v-spacer></v-spacer>
      <v-btn color="white" text @click="declineTerms">{{ $t('terms_popup.decline') }}</v-btn>
      <v-btn color="primary" @click="acceptTerms">{{ $t('terms_popup.accept') }}</v-btn>
    </template>
  </basic-dialog>
</template>

<script>
import BasicDialog from '@/components/BasicDialog.vue';

export default {
  name: 'TermsPopup',
  components: {
    BasicDialog
  },
  data() {
    return {
      showDialog: false,
    };
  },
  created() {
    // Listen for the show-terms-popup event
    this.$root.$on('show-terms-popup', this.showTermsDialog);
  },
  beforeDestroy() {
    // Clean up event listener
    this.$root.$off('show-terms-popup', this.showTermsDialog);
  },
  computed: {
    termsLink() {
      const locale = this.$i18n.locale;
      switch (locale) {
        case 'fi': return 'https://www.harvia.com/fi/tietosuojaseloste/';
        case 'en': return 'https://www.harvia.com/en/privacy-notice/';
        case 'sv': return 'https://www.harvia.com/sv/sekretessmeddelande/';
      }
      return 'https://www.harvia.com/en/privacy-notice/';
    }
  },
  methods: {
    showTermsDialog() {
      // Check if terms have been accepted before showing
      const termsAccepted = localStorage.getItem('termsAccepted');
      console.log(termsAccepted)
      if (!termsAccepted) {
        this.showDialog = true;
      }
    },
    declineTerms() {
      let newLocation = 'https://www.harvia.com/';
      const locale = this.$i18n.locale;
      switch (locale) {
        case 'fi':
          newLocation = 'https://www.harvia.com/fi/';
          break;
        case 'en':
          newLocation = 'https://www.harvia.com/en/';
          break;
        case 'sv':
          newLocation = 'https://www.harvia.com/sv/';
          break;
        default: newLocation = 'https://www.harvia.com/';
      }
      window.location.href = newLocation;
    },
    acceptTerms() {
      // Save in localStorage
      localStorage.setItem('termsAccepted', 'true');
      this.showDialog = false;
      this.$emit('terms-accepted');
    }
  }
};
</script>

<style lang="scss">
.terms-content {
  max-height: calc(100vh - 230px);
  overflow-y: auto;
}
</style>